import {
  Box,
  Container,
  Grid,
  MenuItem,
  TextField,
  Typography
} from "@mui/material";
import React, { useState } from "react";
import InfoIcon from "../../assets/images/infoIcon.svg";
import CustomButton from "../../common/button/CustomButton";
// import GjnDocument from "../../assets/pdf/testdocument.pdf";
// import { BASE_URL } from "../../constants/portConstants";
import axios from "axios";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CircularProgress from "@mui/material/CircularProgress";
import { notify } from "../../utils/handler";
const InquiryForm = () => {
  const [error, setError] = useState(null);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [formStatus, setFormStatus] = useState(""); 
  const [isSubmitting, setIsSubmitting] = useState(false);

  // const handleSubmit = async () => {
  //   setIsSubmitting(true);
  //   if (
  //     name === "" ||
  //     email === "" ||
  //     subject === "" ||
  //     message === "" ||
  //     phone === "" ||
  //     company === ""
  //   ) {
  //     setError(true);
  //     return;
  //   } else {
  //     setError(null);
  //   }
  
  //   try {
  //     const apikey = "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";
  //     const endpoint = "https://api.brevo.com/v3/smtp/email";
  
  //     const sender = {
  //       name: "グローバルジャパンネットワーク",
  //       email: "v.gowthaman@g-japan.com",
  //     };
  
  //     const recipientEmail = "n.basha@g-japan.com";
  
  //     const htmlContent = `
  //       <html>
  //         <head>
  //           <title>グローバルジャパンネットワーク - Contact Form</title>
  //           <style>
  //             body, h1, p {
  //               font-family: "Meiryo", "Hiragino Kaku Gothic Pro", "Yu Gothic", "Noto Sans JP", "MS Gothic", sans-serif;
  //             }
  //           </style>
  //         </head>
  //         <body>
  //           <div>
  //             <h1 style="margin-bottom: 20px">お問い合わせ内容</h1>
  //             <p><strong>問い合わせ種類:</strong> ${subject}</p>
  //             <p><strong>会社名/組織名:</strong> ${company}</p>
  //             <p><strong>お名前:</strong> ${name}</p>
  //             <p><strong>メールアドレス:</strong> ${email}</p>
  //             <p><strong>電話番号:</strong> ${phone}</p>
  //             <p><strong>お問い合わせ内容:</strong> ${message}</p>
  //           </div>
  //           <div style="margin-top: 50px">
  //             <img style="width: 250px; margin-bottom:10px" src="https://gjnetwork.jp/static/media/logo.736b367cff6e04f1fcb198733b08011d.svg?nocache=12345" alt="global japan network limited" />
  //           </div>
  //         </body>
  //       </html>
  //     `;
  
  //     // eslint-disable-next-line no-unused-vars
  //     const response = await axios.post(
  //       '/api/send-email',
  //       {
  //         sender,
  //         subject: "グローバルジャパンネットワーク Contact Form",
  //         to: [{ email: recipientEmail }],
  //         htmlContent,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           "api-key": apikey,
  //         },
  //       }
  //     );
      

  //     const getBase64FromUrl = async (url) => {
  //       const response = await fetch(url);
  //       const buffer = await response.arrayBuffer();
  //       const base64String = btoa(
  //         new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), "")
  //       );
  //       return base64String;
  //     };

  //     // const getBase64FromUrl = async (url) => {
  //     //   const response = await fetch(url);
  //     //   const blob = await response.blob();

  //     //   return new Promise((resolve, reject) => {
  //     //     const reader = new FileReader();
  //     //     reader.onloadend = () => {
  //     //       const base64data = reader.result.split(',')[1]; // Strip the data: prefix
  //     //       resolve(base64data);
  //     //     };
  //     //     reader.onerror = reject;
  //     //     reader.readAsDataURL(blob); // This handles binary safely
  //     //   });
  //     // };

  //     //send document as automatic mail to the entered email //
  //     if (subject.trim().toLowerCase() === "資料ダウンロード") {
  //       const htmlContentUser = `
  //         <html>
  //           <body>
  //             <h2>資料ダウンロードのご案内</h2>
  //             <p>${name} 様</p>
  //             <p>Global Japan Network にお問い合わせいただきありがとうございます。</p>
  //             <p>添付の資料をご確認ください。</p>
  //             <br/>
  //             <div style="margin-top: 50px">
  //               <img style="width: 250px; margin-bottom:10px" src="https://gjnetwork.jp/static/media/logo.736b367cff6e04f1fcb198733b08011d.svg?nocache=12345" alt="global japan network limited" />
  //             </div>
  //           </body>
  //         </html>
  //       `;

  //       const base64File = await getBase64FromUrl(GjnDocument); // adjust path as needed

  //       await axios.post(endpoint, {
  //         sender,
  //         subject: "【グローバルジャパンネットワーク】資料ダウンロードのご案内",
  //         to: [{ email }], // user’s own email
  //         htmlContent: htmlContentUser,
  //         attachment: [
  //           {
  //             name: "資料.pdf",
  //             content: base64File,
  //           }
  //         ]
  //       }, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           "api-key": apikey,
  //         },
  //       });
  //     }
  
  //     notify("Inquiry submission successfully!", "success");
  //     setName("");
  //     setEmail("");
  //     setSubject("");
  //     setMessage("");
  //     setPhone("");
  //     setCompany("");
  //     setFormStatus("success");
  //   } catch (error) {
  //     console.error("Error response from Brevo:", error);
  //     notify("Inquiry submission failed!");
  //     setFormStatus("error");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };
  
  // const handleSubmit = async () => {
  //   setIsSubmitting(true);

  //   if (
  //     name === "" ||
  //     email === "" ||
  //     subject === "" ||
  //     message === "" ||
  //     phone === "" ||
  //     company === ""
  //   ) {
  //     setError(true);
  //     setIsSubmitting(false);
  //     return;
  //   } else {
  //     setError(null);
  //   }

  //   try {
  //     const htmlContent = `
  //       <html>
  //         <head>
  //           <title>グローバルジャパンネットワーク - Contact Form</title>
  //           <style>
  //             body, h1, p {
  //               font-family: "Meiryo", "Hiragino Kaku Gothic Pro", "Yu Gothic", "Noto Sans JP", "MS Gothic", sans-serif;
  //             }
  //           </style>
  //         </head>
  //         <body>
  //           <div>
  //             <h1 style="margin-bottom: 20px">お問い合わせ内容</h1>
  //             <p><strong>問い合わせ種類:</strong> ${subject}</p>
  //             <p><strong>会社名/組織名:</strong> ${company}</p>
  //             <p><strong>お名前:</strong> ${name}</p>
  //             <p><strong>メールアドレス:</strong> ${email}</p>
  //             <p><strong>電話番号:</strong> ${phone}</p>
  //             <p><strong>お問い合わせ内容:</strong> ${message}</p>
  //           </div>
  //         </body>
  //       </html>
  //     `;

  //     const res = await axios.post('/api/send-email', {
  //       sender: {
  //         name: "グローバルジャパンネットワーク",
  //         email: "vikas@g-japan.com",
  //       },  
  //       to: [{ email: "v.gowthaman@g-japan.com" }],
  //       subject: "グローバルジャパンネットワーク Contact Form",
  //       htmlContent,
  //     });

  //     if (res.data.success) {
  //       notify("Inquiry submission successfully!", "success");
  //       setName("");
  //       setEmail("");
  //       setSubject("");
  //       setMessage("");
  //       setPhone("");
  //       setCompany("");
  //       setFormStatus("success");
  //     } else {
  //       throw new Error("Submission failed");
  //     }

  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //     notify("Inquiry submission failed!");
  //     setFormStatus("error");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };
  
  const handleSubmit = async () => {
    setIsSubmitting(true);

    if (
      name === "" ||
      email === "" ||
      subject === "" ||
      message === "" ||
      phone === "" ||
      company === ""
    ) {
      setError(true);
      setIsSubmitting(false);
      return;
    } else {
      setError(null);
    }

    try {
      const res = await axios.post(
        "https://wpgjnetwork.azurewebsites.net/wp-json/custom/v1/send-email",
        {
          name,
          email,
          subject,
          message,
          phone,
          company,
        }
      );

      if (res.data.success) {
        notify("Inquiry submission successful!", "success");
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
        setPhone("");
        setCompany("");
        setFormStatus("success");
      } else {
        throw new Error("Submission failed");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      notify("Inquiry submission failed!");
      setFormStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <Container>
      <Box py={6}>
        <form noValidate autoComplete="off">
          <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
            <Grid item xs={12} sm={4} container alignItems="center">
              <img src={InfoIcon} alt="" />
              <Typography
                variant="h6"
                sx={{
                  ml: 1,
                  fontFamily: "Noto Sans JP, sans-serif",
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#000000",
                }}
              >
                問い合わせ種類
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                select
                fullWidth
                defaultValue={"選択してください"}
                value={subject}
                variant="outlined"
                label={!subject ? "選択してください" : ""}
                onChange={(e) => {
                  setSubject(e.target.value);
                }}
                sx={{
                  border: "1px solid #E6E6E6",
                  borderRadius: "5px",
                  background: "#F6F6F6",
                  height: "55px",
                  fontFamily: "Noto Sans JP, sans-serif",
                  "&:hover": {
                    border: "1px solid #9a9a9a",
                  },
                  "&.Mui-focused": {
                    border: "1px solid #9a9a9a",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .MuiInputLabel-root": {
                    color: "#898989",
                    fontFamily: "Noto Sans JP, sans-serif",
                    fontSize: "14px",
                    fontWeight: 400,
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    display: "none",
                  },
                }}
              >
                <MenuItem value="仕事（プロジェクト）の相談をしたい">
                  仕事（プロジェクト）の相談をしたい
                </MenuItem>
                <MenuItem value="採用について聞きたい">
                  採用について聞きたい
                </MenuItem>
                <MenuItem value="資料ダウンロード">
                  資料ダウンロード
                </MenuItem>
                <MenuItem value="その他">その他</MenuItem>
              </TextField>
            </Grid>
          </Grid>

          {/* 会社名/組織名 */}
          <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
            <Grid item xs={12} sm={4} container alignItems="center">
              <img src={InfoIcon} alt="" />
              <Typography
                variant="h6"
                sx={{
                  ml: 1,
                  fontFamily: "Noto Sans JP, sans-serif",
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#000000",
                }}
              >
                会社名/組織名
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="例) 株式会社あすなる"
                value={company}
                onChange={(e) => {
                  setCompany(e.target.value);
                }}
                sx={{
                  border: "1px solid #E6E6E6",
                  borderRadius: "5px",
                  background: "#F6F6F6",
                  height: "55px",
                  fontFamily: "Noto Sans JP, sans-serif",
                  "&:hover": {
                    border: "1px solid #9a9a9a",
                  },
                  "&.Mui-focused": {
                    border: "1px solid #9a9a9a",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .MuiInputBase-input": {
                    fontFamily: "Noto Sans JP, sans-serif",
                    fontSize: "14px",
                    fontWeight: 400,
                  },
                  "& ::placeholder": {
                    fontFamily: "Noto Sans JP, sans-serif",
                    fontSize: "14px",
                    fontWeight: 400,
                  }
                }}
              />
            </Grid>
          </Grid>

          {/* お名前 */}
          <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
            <Grid item xs={12} sm={4} container alignItems="center">
              <img src={InfoIcon} alt=""/>
              <Typography
                variant="h6"
                sx={{
                  ml: 1,
                  fontFamily: "Noto Sans JP, sans-serif",
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#000000",
                }}
              >
                お名前
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="例) 山田太郎"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                sx={{
                  border: "1px solid #E6E6E6",
                  borderRadius: "5px",
                  background: "#F6F6F6",
                  height: "55px",
                  fontFamily: "Noto Sans JP, sans-serif",
                  "&:hover": {
                    border: "1px solid #9a9a9a",
                  },
                  "&.Mui-focused": {
                    border: "1px solid #9a9a9a", // Add this for the focused state
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none", // Remove the default MUI border
                  },
                  "& .MuiInputBase-input": {
                    fontFamily: "Noto Sans JP, sans-serif",
                    fontSize: "14px",
                    fontWeight: 400,
                  },
                  "& ::placeholder": {
                    fontFamily: "Noto Sans JP, sans-serif",
                    fontSize: "14px",
                    fontWeight: 400,
                  }
                }}
              />
            </Grid>
          </Grid>

          {/* メールアドレス */}
          <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
            <Grid item xs={12} sm={4} container alignItems="center">
              <img src={InfoIcon} alt=""/>
              <Typography
                variant="h6"
                sx={{
                  ml: 1,
                  fontFamily: "Noto Sans JP, sans-serif",
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#000000",
                }}
              >
                メールアドレス
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="例) info@sample.co.jp"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                sx={{
                  border: "1px solid #E6E6E6",
                  borderRadius: "5px",
                  background: "#F6F6F6",
                  height: "55px",
                  fontFamily: "Noto Sans JP, sans-serif",
                  "&:hover": {
                    border: "1px solid #9a9a9a",
                  },
                  "&.Mui-focused": {
                    border: "1px solid #9a9a9a", // Add this for the focused state
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none", // Remove the default MUI border
                  },
                  "& .MuiInputBase-input": {
                    fontFamily: "Noto Sans JP, sans-serif",
                    fontSize: "14px",
                    fontWeight: 400,
                  },
                  "& ::placeholder": {
                    fontFamily: "Noto Sans JP, sans-serif",
                    fontSize: "14px",
                    fontWeight: 400,
                  }
                }}
              />
            </Grid>
          </Grid>

          {/* 電話番号 */}
          <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
            <Grid item xs={12} sm={4} container alignItems="center">
              <img src={InfoIcon} alt=""/>
              <Typography
                variant="h6"
                sx={{
                  ml: 1,
                  fontFamily: "Noto Sans JP, sans-serif",
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#000000",
                }}
              >
                電話番号
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="例) 08012341234"
                value={phone}
                onChange={(e) => {
                  setPhone(e.target.value);
                }}
                sx={{
                  border: "1px solid #E6E6E6",
                  borderRadius: "5px",
                  background: "#F6F6F6",
                  height: "55px",
                  fontFamily: "Noto Sans JP, sans-serif",
                  "&:hover": {
                    border: "1px solid #9a9a9a",
                  },
                  "&.Mui-focused": {
                    border: "1px solid #9a9a9a", // Add this for the focused state
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none", // Remove the default MUI border
                  },
                  "& .MuiInputBase-input": {
                    fontFamily: "Noto Sans JP, sans-serif",
                    fontSize: "14px",
                    fontWeight: 400,
                  },
                  "& ::placeholder": {
                    fontFamily: "Noto Sans JP, sans-serif",
                    fontSize: "14px",
                    fontWeight: 400,
                  }
                }}
              />
            </Grid>
          </Grid>

          {/* お問い合わせ内容 */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={4} container alignItems="baseline">
              <img src={InfoIcon} alt=""/>
              <Typography
                variant="h6"
                sx={{
                  ml: 1,
                  fontFamily: "Noto Sans JP, sans-serif",
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#000000",
                }}
              >
                お問い合わせ内容
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                multiline
                rows={11}
                placeholder="あなたのメッセージ"
                variant="outlined"
                value={message}
                onChange={(e) => {
                  setMessage(e.target.value);
                }}
                sx={{
                  border: "1px solid #E6E6E6",
                  borderRadius: "5px",
                  background: "#F6F6F6",
                  fontFamily: "Noto Sans JP, sans-serif",
                  "&:hover": {
                    border: "1px solid #9a9a9a",
                  },
                  "&.Mui-focused": {
                    border: "1px solid #9a9a9a", // Add this for the focused state
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none", // Remove the default MUI border
                  },
                  "& .MuiInputBase-input": {
                    fontFamily: "Noto Sans JP, sans-serif",
                    fontSize: "14px",
                    fontWeight: 400,
                  },
                  "& ::placeholder": {
                    fontFamily: "Noto Sans JP, sans-serif",
                    fontSize: "14px",
                    fontWeight: 400,
                  }
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
            <Grid item xs={12} sm={4} container alignItems="center"></Grid>
            <Grid item xs={12} sm={8}>
              {/* <Button
                variant="contained"
                color="warning"
                type="submit"
                sx={{
                  width: "auto",
                  borderRadius: "30px",
                  fontSize: "16px",
                  py: 1,
                  padding:'10px 10px 10px 20px'
                }}
              >
                送信
              </Button> */}
              {error ? (
                <Typography
                  variant="body2"
                  sx={{
                    color: "red",
                    fontSize: "14px",
                    fontWeight: 700,
                    fontFamily: "Noto Sans JP, sans-serif",
                  }}
                >
                  Please fill all details
                </Typography>
              ) : (
                error === false && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "green",
                      fontSize: "14px",
                      fontWeight: 700,
                      fontFamily: "Noto Sans JP, sans-serif",
                    }}
                  >
                    Inquiry submission successfully!
                  </Typography>
                )
              )}
              <Box
                sx={{
                  mt: {
                    xs: 0,
                    sm: 4,
                  },
                }}
                // onClick={() => handleSubmit()}
                onClick={() => !isSubmitting && handleSubmit()}
              >
                {/* <CustomButton text={"送信"}  disabled={isSubmitting} /> */}
                {isSubmitting ? (
                  <CircularProgress size={24} sx={{ color: "#ea5a15" }} />
                ) : (
                  <CustomButton text={"送信"} disabled={isSubmitting} />
                )}
              </Box>
              <Typography
                variant="body2"
                sx={{
                  textAlign: "start",
                  mt: 3,
                  color: "#898989",
                  fontSize: "14px",
                  fontWeight: 700,
                  fontFamily: "Noto Sans JP, sans-serif",
                }}
              >
                プライバシーポリシーについて同意したものとみなされます
              </Typography>
            </Grid>
          </Grid>
        </form>

        <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
          <Grid item xs={12} sm={4} container alignItems="center"></Grid>
          <Grid item xs={12} sm={8}>
          {formStatus === "success" && (
            <div style={{ color: "green", marginBottom: "10px", display: 'flex', alignItems: 'center', gap: '5px'}}>
                <CheckCircleIcon />
                <Typography>送信が完了しました</Typography>
            </div>
          )}

          {formStatus === "error" && (
              <div style={{ color: "red", marginBottom: "10px", display: 'flex', alignItems: 'center', gap: '5px'}}>
                  <CancelIcon />
                  <Typography>フォームの送信中にエラーが発生しました。</Typography>
              </div>
          )}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default InquiryForm;
